<template>
  <v-layout class="profile" align-center>
    <v-flex xs12 sm8 md6 lg4 offset-sm2 offset-md3 offset-lg4 v-if="localUser">
      <v-card class="elevation-3" xs12 sm8 md4>
        <v-card-title>
          <v-layout align-center justify-center>
            <v-avatar v-if="userAvatarUrl" size=128>
              <img :src="userAvatarUrl" class="userLogo">
            </v-avatar>
            <v-icon v-else size=128>person_outline</v-icon>
          </v-layout>
        </v-card-title>

        <v-card-text>
          <v-form
            ref="form"
            lazy-validation
            >
            <v-text-field prepend-icon="email"
              v-model="localUser.email"
              name="email"
              label="Email"
              type="text"
              :rules="[rules.required]"
              ></v-text-field>

            <v-text-field prepend-icon="person"
              name="name"
              label="Name"
              type="text"
              v-model="localUser.name"
              ></v-text-field>

            <v-layout :style="'background: url(' + userAvatarUrl + ') no-repeat center;'">
              <v-flex>
                <vue-dropzone ref='logoDropzone' id='dropzone' :options='dropzoneOptions' @vdropzone-queue-complete="dzQueueComplete" style="opacity: 0.9;"></vue-dropzone>
              </v-flex>
            </v-layout>
          </v-form>

          <v-alert :value="updated" color="success" icon="check" outline class="mt-2"> Profile updated </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="updateUser()" :disabled="!localUser.email">Update profile</v-btn>
        </v-card-actions>
      </v-card>
      <v-card class="mt-3 participation">
        <v-card-title class="text-uppercase subheading">
          <v-avatar size=48>
            <v-icon color="primary" large>ballot</v-icon>
          </v-avatar>
          <span class="subheading text-uppercase pl-2">
            Participation
          </span>
        </v-card-title>

        <v-card-text>
          <div v-for="(project, idx) in projects" :key="idx">
            <v-layout row>
              <v-flex class="xs6 text-no-wrap text-truncate subheading">
                <v-avatar size=24>
                  <img :src="projectLogoThumbUrl(project.id)" v-if="projectLogoThumbUrl(project.id)">
                  <v-icon color="primary" small v-else>ballot</v-icon>
                </v-avatar>
                {{project.attributes.name}}
                <br>
                <span class="caption pl-4">since {{membershipFor(project).attributes.created_at|formatDateLong}}</span>
              </v-flex>
              <v-flex class="xs6 text-no-wrap text-truncate text-xs-right">
                <v-btn color="primary" @click="deleteMembership(membershipFor(project))" v-if="canLeave(project)">Leave</v-btn>
                <v-btn color="warning" @click="deleteProject = project" v-else>Delete</v-btn>
              </v-flex>
            </v-layout>
            <v-layout row class="mb-5">
              <v-flex class="xs6 text-no-wrap text-truncate">
                <span class="pl-4">Seats</span>
                <br>
                <span class="caption pl-4">Used: {{project.attributes.seats.used}}</span>
                <br>
                <span class="caption pl-4">Available: {{project.attributes.seats.available}}</span>
              </v-flex>
            </v-layout>
          </div>
          <v-alert :value="true" color="info" icon="info" outline class="mt-2"> You can only leave a project if you are not the last user. </v-alert>
        </v-card-text>
      </v-card>

    <v-dialog
      v-if="deleteProject"
      v-model="deleteProject"
      max-width="500px"
      persistent
      lazy
      :fullscreen="$vuetify.breakpoint.xsOnly"
      >
      <projectDelete :project="deleteProject"></projectDelete>
    </v-dialog>

    </v-flex>
  </v-layout>
</template>

<script>
  import { EventBus } from '@/utilities/event-bus'
  import authentication from '@/utilities/authentication'

  import vueDropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'

  import userService from '@/services/user'
  import projectService from '@/services/project'
  import memberService from '@/services/member'

  import projectDelete from '@/components/project/_delete'

  export default {
    name: 'profile-show',

    data () {
      return {
        auth: authentication,
        user: null,
        localUser: null,
        projects: [],
        deleteProject: null,
        updated: false,
        dropzoneOptions: {
          url: '#',
          method: 'put',
          paramName: 'user[avatar]',
          thumbnailWidth: 150,
          maxFilesize: 5.0,
          maxFiles: 1,
          acceptedFiles: 'image/*',
          headers: {
            'X-User-Email': authentication.username(),
            'X-User-Token': authentication.token()
          },
          dictDefaultMessage: 'Upload your photo/avatar',
          // we don't want DZ to auto-upload the files, we need to make sure it saves first
          autoProcessQueue: false
        },
        rules: {
          required: value => !!value || 'Required'
        }
      }
    },

    components: {
      vueDropzone,
      projectDelete
    },

    computed: {
      userAvatarUrl () {
        if (this.user && this.user.links && this.user.links.avatar_large_uri) {
          return (process.env.API_URL + this.user.links.avatar_large_uri)
        }
      }
    },

    mounted () {
      EventBus.$on('project-deleted', (payload) => {
        if (payload) {
          this.projects = this.projects.filter(prj => parseInt(prj.id) !== parseInt(payload.id))
        }
        this.deleteProject = false
      })

      this.loadUser()
      this.loadProjects()
    },

    methods: {
      loadUser () {
        userService.show(
          (data) => {
            this.user = Object.assign({}, data)
            this.dropzoneOptions.url = process.env.API_URL + (data.links.update_uri) + '.json'
            this.localUser = Object.assign({}, data.attributes)
          },
          (err) => {
            console.log(err)
          },
         this.auth.userId()
        )
      },

      updateUser () {
        if (this.$refs.form.validate()) {
          userService.update(
            (data) => {
              if (this.$refs.logoDropzone.getQueuedFiles().length > 0) {
                this.$refs.logoDropzone.processQueue()
              } else {
                // no files queued, so just pretend we are done
                this.dzQueueComplete()
              }
              this.updated = true
            },
            (err) => {
              console.log(err)
              this.updated = false
            },
            this.localUser
          )
        }
      },

      dzQueueComplete (file, xhr, formData) {
        this.$refs.logoDropzone.removeAllFiles()
        // NOTE: there is a catch here: when we save the user we get the links to the OLD avatar. We need to reload the user once the new image is saved, so we
        // can send that back and the caller does not have to deal with it.
        this.loadUser()
      },

      loadProjects () {
        projectService.index(
          (data) => {
            this.projects = []
            data.forEach((prj) => {
              this.loadMembers(prj)
            })
          },
          (err) => {
            console.log(err)
          }
        )
      },

      loadMembers (project) {
        memberService.projectIndex(
          (data) => {
            project.members = data.filter(m => !m.attributes.discarded_at)
            this.projects.push(project)
            this.projects.sort((a, b) => { return a.attributes.name.toUpperCase().localeCompare(b.attributes.name.toUpperCase()) })
          },
          (err) => {
            console.log(err)
          },
          project.id
        )
      },

      canLeave (project) {
        let owners = project.members.filter(m => (m.attributes.role === 'owner') && !this.auth.isCurrentUser(m.relationships.user.data.id))
        return owners.length > 0
      },

      membershipFor (project) {
        return project.members.find(m => this.auth.isCurrentUser(m.relationships.user.data.id))
      },

      projectLogoThumbUrl (projectId) {
        let project = this.projects.find(pr => (parseInt(pr.id) === parseInt(projectId)))
        if (project.links && project.links.logo_thumb_uri) {
          return (process.env.API_URL + project.links.logo_thumb_uri)
        }
        return null
      },

      deleteMembership (membership) {
        let projectId = membership.relationships.project.data.id
        memberService.projectDelete(
          (data) => {
            this.projects = this.projects.filter(prj => parseInt(prj.id) !== parseInt(projectId))
          },
          (err) => {
            console.log(err)
          },
          projectId,
          membership.id
        )
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-avatar  {
    i {
      border: 2px solid lightgrey !important;
    }
  }

  .participation .v-card__title {
    background-color: #cfcfcf;
  }
</style>



// WEBPACK FOOTER //
// src/components/profile/show.vue